import * as React from 'react';
import { useEffect, Fragment } from 'react';
import Box from '@mui/material/Box';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import Divider from '@mui/material/Divider';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import { Link as RouterLink } from 'react-router-dom';
import { Link } from '@mui/material';
import { useSelector } from 'react-redux';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Avatar from '@mui/material/Avatar';
import Typography from '@mui/material/Typography';
import Rider from './Rider';
import Online from './Online';
import Offline from './Offline';
import Editor from './Editor';
import Admin from './Admin';
import CssBaseline from '@mui/material/CssBaseline';

export default function SideBar() {
  const user = useSelector((state) => state.user.user);
  const isAuth = useSelector((state) => state.auth.isAuthenticated);
  const userRole = useSelector((state) => state.user.currentRole);

  const shortenAddress = (address) => {
    if (!address) return '';
    if (address.length > 9) {
      return address.substring(0, 3) + '...' + address.substring(address.length - 6);
    }
    return address;
  };

  const getInitial = (name) => {
    if (!name) return 'A';
    return name.charAt(0).toUpperCase();
  };

  const [state, setState] = React.useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  });

  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event &&
      event.type === 'keydown' &&
      (event.key === 'Tab' || event.key === 'Shift')
    ) {
      return;
    }

    setState({ ...state, [anchor]: open });
  };

  useEffect(() => {
    window.addEventListener(
      "toggleSideBar",
      (e) => {
       setState({ ...state, ['left']: true });
      },
      false
    );
    
  }, []);
  
  const list = (anchor) => (
    <Box
      sx={{ width: 250, bgcolor: 'background.paper', color: 'text.primary', minHeight: '100vh', fontFamily: '"Source Sans 3", "Segoe UI", sans-serif'}}
      role="presentation"
      onClick={toggleDrawer(anchor, false)}
      onKeyDown={toggleDrawer(anchor, false)}
    >
      <CssBaseline/>
      {(user.name && isAuth) && 
         <Link to='/profile' component={RouterLink} sx={{ width: '100%', textDecoration: 'none', color: 'inherit', maxWidth: 360 }}>
         <ListItem alignItems="flex-start" sx={{ paddingY: '20px', paddingX: '16px' }}>
         <ListItemAvatar>
           <Avatar 
             alt={user.name} 
             src={user.profile}
             sx={{ 
                  bgcolor: 'action.selected', 
                  color: 'text.primary',
               width: 48,
               height: 48,
               fontSize: '20px',
               fontWeight: 'bold'
             }}
           >
             {!user.profile && getInitial(user.name)}
           </Avatar> 
         </ListItemAvatar>
         <ListItemText
           primary={
             <Typography sx={{ color: 'text.primary', fontFamily: '"Cormorant Garamond", Georgia, serif', fontWeight: 600, fontSize: '20px', lineHeight: 1.1 }}>
               Trust Vault LLC
             </Typography>
           }
           secondary={
             <Typography sx={{ color: 'text.secondary', fontFamily: '"Source Sans 3", "Segoe UI", sans-serif', fontSize: '12px' }}>
               {shortenAddress(user.email || 'trustsvaultllc.com')}
             </Typography>
           }
         />
       </ListItem>
     </Link>
          }
        <Divider />

        {isAuth && user.name ?
            userRole === '' ?
            <Online/>
            : 
            <Fragment>
               {userRole === 'admin' && <Admin/>}      
               {userRole === 'editor' && <Editor/>}
               {userRole === 'dispatch rider' && <Rider/>}              
            </Fragment>
                   
          :
          <Offline/>
          }
    </Box>
  );


  return (
    <div>
          <SwipeableDrawer
            sx={{ zIndex: 2500, }}
            anchor={`left`}
            open={state[`left`]}
            onClose={toggleDrawer(`left`, false)}
            onOpen={toggleDrawer(`left`, true)}
          >
            {list(`left`)}
          </SwipeableDrawer>
    </div>
  );
}
